export const resetZoomOnFloorChange = (setZoomLevel) => {
  setZoomLevel(100);
};

export const applyZoomEffect = (floorMapRef, zoomLevel) => {
  if (floorMapRef?.current) {
    floorMapRef.current.style.transform = `scale(${zoomLevel / 100})`;
    floorMapRef.current.style.transformOrigin = "0 0";
  }
};

export const handleZoomIn = (event, setZoomLevel, zoomLevel, setAnnouncement) => {
  event?.preventDefault?.();
  setZoomLevel((prev) => Math.min(prev + 10, 200));
  setAnnouncement(`Zoom ${zoomLevel} percent`);
};

export const handleZoomOut = (event, setZoomLevel, zoomLevel, setAnnouncement) => {
  event?.preventDefault?.();
  setZoomLevel((prev) => Math.max(prev - 10, 50));
  setAnnouncement(`Zoom ${zoomLevel} percent`);
};

export const handleResetZoom = (setZoomLevel, setAnnouncement) => {
  setZoomLevel(100);
  setAnnouncement("Blueprint has been reset");
};

export const handleFullScreen = (floorMapRef, handleExitFullScreen, handleEscapeKey) => {
  if (floorMapRef?.current) {
    const element = floorMapRef.current;
    if (element.requestFullscreen) element.requestFullscreen();
    else if (element.webkitRequestFullscreen) element.webkitRequestFullscreen();
    else if (element.msRequestFullscreen) element.msRequestFullscreen();

    document.addEventListener("fullscreenchange", handleExitFullScreen);
    document.addEventListener("keydown", handleEscapeKey);
  }
};

export const handleExitFullScreen = (handleEscapeKey) => {
  if (!document.fullscreenElement) {
    const button = document.getElementById("fullScreenButton");
    if (button) {
      setTimeout(() => button.focus(), 50);
    }

    document.removeEventListener("fullscreenchange", handleExitFullScreen);
    document.removeEventListener("keydown", handleEscapeKey);
  }
};

export const handleEscapeKey = (event) => {
  if (event.key === "Escape") {
    document.exitFullscreen();
  }
};

export const handleSliderChange = (event, newValue, setZoomLevel) => {
  setZoomLevel(newValue);
};

export const handleWheel = (event, handleZoomInFn, handleZoomOutFn) => {
  if (event.deltaY < 0) handleZoomInFn(event);
  else if (event.deltaY > 0) handleZoomOutFn(event);
};

export const handleKeyDown = (event, handleZoomInFn, handleZoomOutFn) => {
  if (event.key === "+") handleZoomInFn(event);
  else if (event.key === "-") handleZoomOutFn(event);
};
